import { render } from "./Client.vue?vue&type=template&id=9adb8ede&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=9adb8ede&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9adb8ede"

export default script